<template>
  <div
    class="flex"
    @click="openMenu"
  >
    <BaseSubtitle
      subtitle="Menu"
      class="mr-2"
    />
    <div class="flex flex-col justify-between w-4">
      <div class="bg-black h-px"/>
      <div class="bg-black h-px"/>
      <div class="bg-black h-px"/>
    </div>
  </div>
</template>

<script>
import BaseSubtitle from './BaseSubtitle.vue';
import { OPENED_MENU } from '../analytics';

export default {

  name: 'TheHeaderBurgerMenu',
  components: {
    BaseSubtitle,
  },

  methods: {
    openMenu() {
      this.$store.dispatch('openMenu');
      analytics.track(OPENED_MENU);
    },
  },
};
</script>
